export const captionFonts = [
    {
        name: 'Arial',
        source: 'native',
    },
    {
        name: 'Calibri',
        source: 'native',
    },
    {
        name: 'Consolas',
        source: 'native',
    },
    {
        name: 'Helvetica',
        source: 'native',
    },
    {
        name: 'Open Sans',
        source: 'native',
    },
    {
        name: 'Tahoma',
        source: 'native',
    },
    {
        name: 'Times New Roman',
        source: 'native',
    },
    {
        name: 'Trebuchet MS',
        source: 'native',
    },
    {
        name: 'Verdana',
        source: 'native',
    },
    {
        name: 'Organica',
        source: '/subtitles-fonts/Organica-SemiBold.woff2',
    },
];
export const loadCaptionFont = async (fontName) => {
    const fontFaces = [...document.fonts];
    const isFontLoaded = fontFaces.some((fontFace) => fontFace.family === fontName && fontFace.status === 'loaded');
    if (isFontLoaded) {
        return;
    }
    const fontToLoad = captionFonts.find((font) => font.name === fontName && font.source !== 'native');
    if (fontToLoad !== undefined) {
        const fontFace = new FontFace(fontToLoad.name, `url(${fontToLoad.source})`);
        await fontFace.load();
        document.fonts.add(fontFace);
    }
};
